import { NavLink } from "react-router-dom"
import SideNav from "../SideNav"
import { RxDashboard } from "react-icons/rx";
import { IoSettingsOutline, IoBagHandleOutline } from "react-icons/io5";
import { BsBagPlus } from "react-icons/bs";
import { LuUsers, LuUserPlus } from "react-icons/lu";
import { MdOutlinePointOfSale } from "react-icons/md";

const AdminNavs = ({ expandedNav, setExpandedNav }) => {

    return (
        <SideNav expandedNav={expandedNav} setExpandedNav={setExpandedNav}>
            <div className=" text-gray-500 font-semibold mb-3 mt-6 uppercase text-lg">MENU</div>
            <NavLink className={({ isActive }) => (isActive ? ' text-tripstore-gold' : ' text-gray-800')} to={'/admin/dashboard'}>
                <div className=" flex items-center gap-4 cursor-pointer hover:text-tripstore-gold my-4">
                    <RxDashboard />
                    <span>Dashboard</span>
                </div>
            </NavLink>
            <NavLink className={({ isActive }) => (isActive ? ' text-tripstore-gold' : ' text-gray-800')} to={'/admin/sales'}>
                <div className=" flex items-center gap-4 cursor-pointer hover:text-tripstore-gold my-4">
                    <MdOutlinePointOfSale />
                    <span>Sales</span>
                </div>
            </NavLink>

            <div className=" text-gray-500 font-semibold mb-3 mt-6 uppercase text-lg">PRODUCT</div>
            <NavLink className={({ isActive }) => (isActive ? ' text-tripstore-gold' : ' text-gray-800')} to={'/admin/add_product'}>
                <div className=" flex items-center gap-4 cursor-pointer hover:text-tripstore-gold my-4">
                    <BsBagPlus />
                    <span>Add Products</span>
                </div>
            </NavLink>
            <NavLink className={({ isActive }) => (isActive ? ' text-tripstore-gold' : ' text-gray-800')} to={'/admin/inventory'}>
                <div className=" flex items-center gap-4 cursor-pointer hover:text-tripstore-gold my-4">
                    <IoBagHandleOutline />
                    <span>Inventory</span>
                </div>
            </NavLink>

            <div className=" text-gray-500 font-semibold mb-3 mt-6 uppercase text-lg">Users</div>
            <NavLink className={({ isActive }) => (isActive ? ' text-tripstore-gold' : ' text-gray-800')} to={'/admin/add_sales_rep'}>
                <div className=" flex items-center gap-4 cursor-pointer hover:text-tripstore-gold my-4">
                    <LuUserPlus />
                    <span>Add Sales Rep</span>
                </div>
            </NavLink>
            <NavLink className={({ isActive }) => (isActive ? ' text-tripstore-gold' : ' text-gray-800')} to={'/admin/users'}>
                <div className=" flex items-center gap-4 cursor-pointer hover:text-tripstore-gold my-4">
                    <LuUsers />
                    <span>All Users</span>
                </div>
            </NavLink>

            <div className=" text-gray-500 font-semibold mb-3 mt-6 uppercase text-lg">Others</div>
            <NavLink className={({ isActive }) => (isActive ? ' text-tripstore-gold' : ' text-gray-800')} to={'/admin/settings'}>
                <div className=" flex items-center gap-4 cursor-pointer hover:text-tripstore-gold my-4">
                    <IoSettingsOutline />
                    <span>Settings</span>
                </div>
            </NavLink>
        </SideNav>
    )
}

export default AdminNavs